<template>

  <div class="mt-2">


    <router-view />

  </div>

</template>

<script>

export default {

  name: 'AdditionalInfo',

  metaInfo() {
    return {
      title: this.$t('additionalInfo.metaTitle')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/additional-information/index.vue